export default __webpack_public_path__ + "static/media/Project-level_documentation.047bd5a8.jpg";